/**
 * Où mène « Commencer » — une seule décision, lue partout.
 *
 * Deux portes d'entrée coexistent, et c'est voulu :
 *
 *   /analyser  le DÉPÔT SANS INSCRIPTION. Le document d'abord, le compte
 *              plus tard, par un code reçu par email pendant l'analyse.
 *   /signup    l'inscription classique. Elle reste en place, atteignable,
 *              et rien de ce chantier ne la touche — c'est la porte de
 *              qui veut un mot de passe tout de suite, et le repli si le
 *              nouveau parcours doit être refermé.
 *
 * `ENABLE_ANON_INTAKE` (côté serveur, servi par /api/public-config)
 * décide laquelle porte les CTA publics. Le passer à `false` ramène tout
 * le site au parcours d'avant SANS redéploiement et sans rien défaire :
 * `/analyser` continue de répondre pour qui a le lien, mais plus aucun
 * bouton n'y mène.
 *
 * POURQUOI UN HOOK ET NON UNE CONSTANTE. `ROUTE_START` est un littéral de
 * module (`siteV2/routes.js`) : il ne peut pas lire un drapeau qui arrive
 * par le réseau. Un hook peut, et il garde la décision à UN endroit —
 * huit boutons qui choisissent chacun leur destination finiraient par
 * diverger, et c'est le clic le plus important du site.
 *
 * PENDANT LE CHARGEMENT DES DRAPEAUX, on rend `/signup`. Le repli est la
 * porte HISTORIQUE, jamais la nouvelle : un visiteur qui clique dans la
 * première seconde doit atterrir sur un parcours éprouvé, pas sur celui
 * qu'on est en train d'ouvrir.
 */
import { useMemo } from 'react';
import useFeatureFlags from './useFeatureFlags';
import { ROUTE_START } from '../components/siteV2/routes';

/** La route du dépôt sans inscription. */
export const ROUTE_ANALYSE = '/analyser';

export default function useStartRoute() {
  const flags = useFeatureFlags();
  return useMemo(
    () => (flags?.anon_intake_enabled ? ROUTE_ANALYSE : ROUTE_START),
    [flags],
  );
}
